<template>
  <v-container fluid class="px-0 py-15 ma-0">
    <h1 class="header_title mb-6" v-if="name">
      {{ $t("creator.greetings." + randomGreetingNumber, { name: name }) }}
    </h1>
    <NewAccountHousekeeping
      class="mb-6"
      @visible="housekeepingVisible = $event"
    />
    <h3 class="stories__title mb-3">
      {{ $t("creator.dashboard.yourStories") }}
    </h3>
    <div class="story-city-content-container py-7 px-6">
      <div v-if="stories">
        <div class="d-flex justify-space-between align-center mb-5">
          <v-chip class="contributor-count px-6" color="backgroundExtraLight">
            <span class="mr-1">
              {{ stories.edges.length }}
            </span>
            {{ $t("admin.stories.stories") }}
          </v-chip>
          <div
            v-if="isFeatureEnabled('storySorting')"
            class="d-flex align-center justify-space-between"
          >
            <div class="mr-5">{{ $t("creator.dashboard.sortBy") }}:</div>
            <v-select hide-details height="44px"></v-select>
          </div>
        </div>
        <div
          v-if="stories.edges.length == 0"
          class="no-stories-container d-flex flex-column align-center justify-center text-center"
        >
          <h3 class="mb-3">{{ $t("storyHub.noStories") }}</h3>
          <p class="mb-3">
            <i18n path="creator.notSureWhereToStart">
              <router-link :to="{ name: 'creator-resources' }">
                {{ $t("creator.notSureWhereToStart0") }}
              </router-link>
            </i18n>
          </p>
          <CreateStoryButton />
        </div>
        <div v-else class="story-item-container d-flex flex-column">
          <StoryListItem
            v-for="story in stories.edges"
            :key="story.node._id"
            :story="story.node"
          />
        </div>
      </div>
      <div v-else-if="error != undefined">
        {{ error }}
      </div>
      <div v-else>
        <v-skeleton-loader v-for="i in 3" :key="i" class="my-3" type="image" />
      </div>
    </div>
  </v-container>
</template>

<script>
import StoryListItem from "./StoryListItem.vue";
import CreateStoryButton from "./CreateStoryButton";
import StoryMutations from "@/graphql/StoryMutations";
import NewAccountHousekeeping from "./NewAccountHousekeeping.vue";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
import featureFlags from "@/mixins/featureFlags";

const NUMBER_OF_GREETINGS = 11;
export default {
  mixins: [hasLoggedInUser, featureFlags],
  data() {
    return {
      error: undefined,
      randomGreetingNumber: Math.floor(Math.random() * NUMBER_OF_GREETINGS + 1),
      housekeepingVisible: false,
    };
  },
  components: {
    StoryListItem,
    CreateStoryButton,
    NewAccountHousekeeping,
  },
  apollo: {
    stories: {
      variables() {
        return {
          userId: this.user?.id,
        };
      },
      error(error) {
        this.error = error;
      },
      skip() {
        return !this.user;
      },
      query: StoryMutations.getMyStories,
      fetchPolicy: "network-only",
    },
  },
  computed: {
    name() {
      if (
        this.user?.userProfile?.firstName?.length > 0 &&
        this.user.userProfile?.lastName?.length > 0
      ) {
        return this.$t("fullName", {
          firstName: this.user?.userProfile?.firstName,
          lastName: this.user.userProfile.lastName,
        });
      }
      return this.user?.userProfile?.username;
    },
  },
};
</script>

<style lang="scss" scoped>
.contributor-count {
  border-radius: 26px;
  color: var(--v-primaryText-base);
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
}

.contributor-count span {
  font-weight: 700;
}

.story-item-container {
  gap: 10px;
}

.no-stories-container {
  height: 560px;
  border-radius: 20px;
  background-color: var(--v-backgroundBlueTint-base);

  h3 {
    font-size: 24px;
  }

  p {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: $font-spacing;
  }
}
</style>
